var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('div',{staticClass:"my-30"},[_c('button',{ref:"submit-order-btn",staticClass:"btn btn-primary btn-lg px-45 py-15",attrs:{"type":"button"}},[_vm._v("\n      Complete Order\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }